module.exports = __webpack_public_path__ + "img/Pages-icon.eot?edb574e6e5350c2ca2596be473d2f26b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pages/fonts/pages-icon/Pages-icon.eot?-u69vo5
// module id = 620
// module chunks = 0